module.exports = __webpack_public_path__ + "img/zh.e172b164.png";